import React, { useState } from "react";
import { FrontColors } from "../../../models/FrontColors";
import { FrontSpacing } from "../../../models/FrontSpacing";
import { Flex } from "../../BuildingBlocks/Flex";
import { FontQuicksand } from "../../BuildingBlocks/FontQuicksand";
import { FontSize } from "../../BuildingBlocks/FontSize";
import { MaxWidth } from "../../BuildingBlocks/MaxWidth";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { TextAlign } from "../../BuildingBlocks/TextAlign";
import { TextColor } from "../../BuildingBlocks/TextColor";
import { WeightSemiBold } from "../../WeightSemiBold/WeightSemiBold";
import { FPLandingTitle } from "../Simple/FPLandingTitle/FPLandingTitle";
import { FPSimpleLogo } from "../Simple/FPSimpleLogo/FPSimpleLogo";
import { WeightBold } from "../../WeightBold/WeightBold";


export const FPPropertyReportExpiredAccount = (props: {}): JSX.Element => {
    
    return <SpacingColumn
        spacing={FrontSpacing.LARGE_1}
        justifyContent="center"
    >
        {/* LOGO */}
        <Flex justifyContent="center">
            <FPSimpleLogo width="95px" />
        </Flex>

        {/* HEADER */}
        <Flex justifyContent="center">
            <MaxWidth width="530px">
                <FPLandingTitle
                    size={60}
                    color={FrontColors.NEUTRAL_18}
                    align="center"
                >
                    The Probate Hub.
                </FPLandingTitle>
            </MaxWidth>
        </Flex>

        {/* SUBTITLE */}
        <Flex justifyContent="center">
            <MaxWidth width="530px">
                <Flex justifyContent="center">
                    <MaxWidth width="425px">
                        <TextColor color={FrontColors.NEUTRAL_18}>
                            <TextAlign position="center">
                                <FontQuicksand>
                                    <FontSize
                                        size={20}
                                        lineHeight={1.2}
                                    >
                                        <WeightSemiBold>
                                            Your organisation's account has expired. Please contact <WeightBold>hello@sailprobate.co.uk</WeightBold> to get your account reactivated.
                                        </WeightSemiBold>
                                    </FontSize>
                                </FontQuicksand>
                            </TextAlign>
                        </TextColor>
                    </MaxWidth>
                </Flex>
            </MaxWidth>
        </Flex>

        
    </SpacingColumn>;
};
